import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgZorroAntdModule, NZ_I18N, NZ_MESSAGE_CONFIG, zh_CN} from 'ng-zorro-antd';
import {registerLocaleData} from '@angular/common';
import zh from '@angular/common/locales/zh';
import {CookieModule} from 'ngx-cookie';
import {NoopInterceptor} from './common/library/noop-interceptor';
import {LoadingComponent} from './common/library/loading/loading.component';
import {LocalStorage} from './common/library/local-storage';
import {LoadingService} from './common/library/loading/loading.service';
import {TokenCookieService} from './common/library/token-cookie.service';
import {AuthGuardService} from './common/library/auth-guard.service';
import {SettingsService} from './common/library/settings.service';
import {NotFountComponent} from './common/abnormal/not-fount/not-fount.component';
import {AttachPartyService} from './common/services/console/attach-party.service';
import {OrgsRenovateService} from './console/orgs-renovate.service';
import {DownloaderService} from './common/services/console/downloader.service';

/** NG-ZORRO - 配置 angular i18n **/
registerLocaleData(zh);

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true},
];

@NgModule({
    declarations: [
        AppComponent,
        NotFountComponent,
        LoadingComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        NgZorroAntdModule,
        CookieModule.forRoot(),
        // ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}) // 忽略警告
    ],
    providers: [
        AttachPartyService,
        DownloaderService,
        LocalStorage,
        SettingsService,
        LoadingService,
        OrgsRenovateService,
        TokenCookieService,
        AuthGuardService,
        httpInterceptorProviders,
        {provide: NZ_I18N, useValue: zh_CN},
        {provide: NZ_MESSAGE_CONFIG, useValue: {nzDuration: 3000, nzMaxStack: 3, nzPauseOnHover: true, nzAnimate: true}}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
